import { Component, Input, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateRange } from '@angular/material/datepicker';
import { ModalFilterCalendarData } from '@shared/components/usf-filtering-modal/model/modal-filter';
import { UsfFilteringOptionComponent } from '@shared/components/usf-filtering-modal/usf-filtering-options/usf-filtering-option/usf-filtering-option-component';
import moment, { Moment } from 'moment';

class CustomDateAdapter extends MomentDateAdapter {
  getDayOfWeekNames(style: 'long' | 'short' | 'narrow') {
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }
}

@Component({
  selector: 'app-usf-filtering-dates-option',
  templateUrl: './usf-filtering-dates-option.component.html',
  styleUrls: ['./usf-filtering-dates-option.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
  ],
})
export class UsfFilteringDatesOptionComponent
  extends UsfFilteringOptionComponent<
    ModalFilterCalendarData,
    { fromDate: number; toDate: number }
  >
  implements OnInit
{
  @Input() show = false;
  @Input() isMobile = false;

  fromIssueDateStr = '';
  toIssueDateStr = '';
  selectedRangeValue: DateRange<Moment> | undefined;
  maxDate = new Date();
  minDate: Date;
  message: string;

  totalFilters = 0;

  ngOnInit(): void {
    this.maxDate = this.data.maxDate ?? this.maxDate;
    this.minDate = this.data.minDate ?? this.minDate;
    this.message = this.data.message ?? this.message;
    this.fromIssueDateStr = this.setNumberToDateString(this.data.fromDate);
    this.toIssueDateStr = this.setNumberToDateString(this.data.toDate);

    this.selectedRangeValue = new DateRange(
      moment.utc(this.fromIssueDateStr, 'MM-DD-YYYY'),
      moment.utc(this.toIssueDateStr, 'MM-DD-YYYY'),
    );
  }

  selectedDateRangeChange(date: Moment) {
    this.fromIssueDateStr = '';
    this.toIssueDateStr = '';
    if (date) {
      if (!this.selectedRangeValue?.start || this.selectedRangeValue.end) {
        this.selectedRangeValue = new DateRange<Moment>(date, null);
        this.data.fromDate = this.setNumericDate(date.toDate());
        this.fromIssueDateStr = this.formatDateToNumber(date.toDate());
        this.data.toDate = null;
        this.optionSelected.emit({
          fromDate: this.data.fromDate,
          toDate: null,
        });
      } else {
        const start = this.selectedRangeValue.start;
        const end = date;
        if (end < start) {
          this.selectedRangeValue = new DateRange<Moment>(end, start);

          this.data.fromDate = this.setNumericDate(end.toDate());
          this.fromIssueDateStr = this.formatDateToNumber(end.toDate());

          this.data.toDate = this.setNumericDate(start.toDate());
          this.toIssueDateStr = this.formatDateToNumber(start.toDate());
        } else {
          this.selectedRangeValue = new DateRange<Moment>(start, end);

          this.data.fromDate = this.setNumericDate(start.toDate());
          this.fromIssueDateStr = this.formatDateToNumber(start.toDate());

          this.data.toDate = this.setNumericDate(end.toDate());
          this.toIssueDateStr = this.formatDateToNumber(end.toDate());
        }
        this.optionSelected.emit({
          fromDate: this.data.fromDate,
          toDate: this.data.toDate,
        });
      }
    }
  }

  formatDateToNumber(date) {
    return (
      '' +
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : '0' + (date.getMonth() + 1)) +
      '/' +
      (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
      '/' +
      date.getFullYear()
    );
  }

  setNumericDate(date) {
    return +(
      '' +
      date.getFullYear() +
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : '0' + (date.getMonth() + 1)) +
      (date.getDate() > 9 ? date.getDate() : '0' + date.getDate())
    );
  }

  setNumberToDateString(dateNumber) {
    if (dateNumber) {
      let dateString = `${dateNumber}`;
      dateString = `${dateString.substring(4, 6)}/${dateString.substring(
        6,
        8,
      )}/${dateString.substring(0, 4)}`;
      return dateString;
    } else {
      return null;
    }
  }
}
